import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Tooltip from 'rc-tooltip';
import _actions from '../../actions';

class ColorChoice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: props.selected,
            displayColorPicker: false,
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.handleClose();
        }
    }

    handleClick = () => {
        this.setState((prevState) => {
            return { displayColorPicker: !prevState.displayColorPicker };
        });
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false });
    };

    handleChange = (color) => {
        this.setState({ displayColorPicker: false, selected: color });
        this.props.setColor(color, this.props.containerId);
    };

    render() {
        // eslint-disable-next-line no-nested-ternary
        const color = this.state.selected === 3 ? this.props.versions.select.primaryText : this.state.selected === 4 ? this.props.versions.select.secondaryText : this.props.versions.select.accentColor;
        // eslint-disable-next-line no-nested-ternary
        const colorText = this.state.selected === 3 ? 'Primary' : this.state.selected === 4 ? 'Secondary' : 'Accent';
        return (
            <div
                ref={this.wrapperRef}
                data-qa={this.props.containerId}
                id={this.props.containerId}
                className="color-choice-wrap-outer"
            >
                <div
                    data-qa={`${this.props.containerId}-picker`}
                    className="color-choice"
                >

                    {/* eslint-disable-next-line */}
                    <div
                        className="color-choice-wrap"
                        data-qa={`${this.props.containerId}-color-choice-wrap`}
                    >
                        <Tooltip
                            placement="top"
                            trigger="[hover, focus]"
                            mouseEnterDelay={0}
                            mouseLeaveDelay={0.1}
                            overlay={<span>{colorText}</span>}
                        >
                            <div
                                aria-label={colorText}
                                className="color-choice"
                                style={{ backgroundColor: color }}
                                onClick={this.handleClick}
                                data-qa={`${this.props.containerId}-color-choice`}
                            />
                        </Tooltip>
                    </div>
                </div>
                {this.state.displayColorPicker ? (
                    <div
                        className="color-choice-popover"
                        data-qa={`${this.props.containerId}-display-picker`}
                    >
                        <div className="item">
                            <button data-qa={`${this.props.containerId}-display-picker-primary-button`} style={{ backgroundColor: this.props.versions.select.primaryText }} type="button" onClick={() => { this.handleChange(3); }} />
                            <label>
                                Primary
                            </label>
                        </div>
                        <div className="item">
                            <button data-qa={`${this.props.containerId}-display-picker-secondary-button`} style={{ backgroundColor: this.props.versions.select.secondaryText }} type="button" onClick={() => { this.handleChange(4); }} />
                            <label>
                                Secondary
                            </label>
                        </div>
                        <div className="item">
                            <button data-qa={`${this.props.containerId}-display-picker-accent-button`} style={{ backgroundColor: this.props.versions.select.accentColor }} type="button" onClick={() => { this.handleChange(2); }} />
                            <label>
                                Accent
                            </label>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ColorChoice);
